sharpen-card {
  display: block;
  border-radius: var(--border-radius-md);
  background-color: var(--color-white);

  &[border="none"] { box-shadow: rgba(0, 0, 0, 0.1) 0px 15px 40px 0px; }
  &[border="thin"] {
    border: var(--border-hair-solid-gray-4);
    border-radius: var(--border-radius-xs);
  }
  &[border="gray"] { border: var(--border-thin-solid-gray-4); }
  &[border="green"] {
    border: var(--border-hair-solid-green);
    box-shadow: rgba(0, 0, 0, 0.075) 0 0.5rem 1.5rem 0.5rem;
    margin: var(--spacing-lg);
  }

  &[padding="small"]  { padding: var(--spacing-sm); }
  &[padding="medium"] { padding: var(--spacing-md); }
  &[padding="large"]  { padding: var(--spacing-lg); }
  &[padding="xl"]     { padding: var(--spacing-xl); }
}

sharpen-card-header {
  display: block;
  background-color: var(--color-evergreen);
  color: var(--color-white);
  font-size: var(--font-size-lg);
  padding: var(--spacing-md);
  border-top-left-radius: var(--border-radius-md);
  border-top-right-radius: var(--border-radius-md);
}

sharpen-card-content {
  display: block;
  &[padding="small"]  { padding: var(--spacing-sm); }
  &[padding="medium"] { padding: var(--spacing-md); }
  &[padding="large"]  { padding: var(--spacing-lg); }
  &[padding="xl"]     { padding: var(--spacing-xl); }
}

